import StoreBody from './StoreBody'
export default StoreBody
